import React from 'react';
import InteractiveCandleBackground from '../components/InteractiveCandleBackground';
import HeroSection from '../components/HeroSection';
import StatsBar from '../components/StatsBar';
import LearningPathsSection from '../components/LearningPathsSection';
import WelvateMethodSection from '../components/WelvateMethodSection';
import ProductsGridSection from '../components/ProductsGridSection';
import HaritikaSection from '../components/HaritikaSection';
import MissionAndTestimonials from '../components/MissionAndTestimonials';
import FaqSection from '../components/FaqSection';
import CtaFooterSection from '../components/CtaFooterSection';

export default function Home() {
  const scrollToFaq = () => {
    const faqElement = document.getElementById('faq');
    if (faqElement) {
      faqElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="relative min-h-screen">
      {/* Candlestick Canvas Background - ONLY FOR HOME PAGE */}
      <InteractiveCandleBackground />

      <div className="relative z-10 space-y-6">
        <HeroSection />
        <StatsBar />
        <LearningPathsSection />
        <WelvateMethodSection />

        {/* Full-Width Risk Disclaimer Banner */}
        <section className="w-full bg-[#FFF5EB] border-y border-[#FED7AA]/60 py-4 px-6 my-6">
          <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-4">
              <div className="w-9 h-9 rounded-full bg-[#EA580C] text-white flex items-center justify-center font-bold text-base shrink-0 shadow-sm">
                !
              </div>
              <p className="text-xs sm:text-sm text-gray-800 leading-relaxed max-w-4xl">
                <strong className="text-gray-900 font-bold">Every investment carries risk.</strong> <span className="italic text-gray-700">Markets rise and fall, and yesterday's returns promise nothing about tomorrow. Everything here is educational — research on your own or speak with a registered advisor before you commit money.</span>
              </p>
            </div>
            <button 
              onClick={scrollToFaq} 
              className="whitespace-nowrap shrink-0 text-xs font-bold text-[#EA580C] border-2 border-[#EA580C]/80 px-5 py-2 rounded-full hover:bg-[#EA580C] hover:text-white transition-all duration-300 shadow-sm"
            >
              How we handle risk →
            </button>
          </div>
        </section>

        <ProductsGridSection />
        <HaritikaSection />
        <MissionAndTestimonials />

        {/* FAQ Section */}
        <div id="faq" className="pt-2">
          <FaqSection />
        </div>

        <CtaFooterSection />
      </div>
    </div>
  );
}